import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import SkillIcon from '../general/SkillIcon';
import SkillCheckboxTableCell from './SkillCheckboxTableCell';
import './SkillEditTable.css';
import { operations as membershipOperations, selectors as membershipSelectors } from '../../state/modules/memberships';
import { operations as skillOperations, selectors as skillSelectors } from '../../state/modules/skills';
import { operations as userOperations, selectors as userSelectors } from '../../state/modules/users';
import {
  operations as certificationOperations,
  selectors as certificationSelectors
} from '../../state/modules/certifications';

import Loader from '../general/Loader';
import { useWindowDimensions } from '../../utils/custom-hooks';
import Table from '../ui-kit/Table';

const emptyObject = {};
const emptyArray = [];

const SkillEditTable = ({
  groupId,
  fetchSkills,
  fetchMemberships,
  fetchUsers,
  fetchCertifications,
  loaded,
  skills,
  memberships,
  usersById,
  membershipIds,
  certificationsByMembershipAndSkillId,
  assignSkill,
  userId
}) => {
  useEffect(() => {
    fetchSkills({ params: { group_ids: groupId } });
    fetchMemberships({
      params: { ids: membershipIds, presentation_type: 'basic' },
      forceFetch: true
    });
    // If an userId is provided as a prop, the component will be in
    // single user mode, and only need to fetch that user's data
    if (userId) {
      fetchUsers({ params: { ids: userId, presentation_type: 'basic' } });
    } else {
      fetchUsers({ params: { group_ids: groupId, presentation_type: 'basic' } });
    }
    fetchCertifications({ params: { group_ids: groupId } });
  }, []);

  const { height } = useWindowDimensions();

  if (!loaded) return <Loader />;

  const membershipsToShow = memberships.filter(membership => membershipIds.includes(membership.id));
  return (
    <div className="overflow-y-scroll" style={{ maxHeight: height * 0.67 }}>
      <Table hover>
        <thead>
          <tr>
            <th className="position-sticky top-0 start-0 z-3" style={{ minWidth: '250px' }}>
              {I18n.t('activerecord.models.user')}
            </th>
            {skills.map(skill => (
              <th
                key={skill.id}
                align="center"
                className="position-sticky top-0 z-2"
                style={{ minWidth: '75px', textAlign: 'center' }}
              >
                <SkillIcon skill={skill} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {membershipsToShow.map(membership => {
            // user may be emtpy beacuse it is a monitor user
            const user = usersById[membership.user_id];
            if (!user) return null;
            return (
              <tr key={membership.id}>
                <td className="position-sticky start-0 z-1">
                  <a href={`/users/${membership.user_id}`} target="_blank" rel="noreferrer">
                    {user.full_name}
                  </a>
                </td>
                {skills.map(skill => (
                  <td align="center" key={`membership_${membership.id}_skill_${skill.id}`}>
                    <SkillCheckboxTableCell
                      membershipId={membership.id}
                      skillId={skill.id}
                      certifications={
                        (certificationsByMembershipAndSkillId[membership.id] || emptyObject)[skill.id] || emptyArray
                      }
                      skillName={skill.name}
                      userName={user.full_name}
                      assignSkill={assignSkill}
                    />
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

const mapStateToProps = state => ({
  skills: skillSelectors.values(state),
  memberships: membershipSelectors.values(state),
  usersById: userSelectors.byId(state),
  loaded:
    userSelectors.initialLoadComplete(state) &&
    membershipSelectors.initialLoadComplete(state) &&
    skillSelectors.initialLoadComplete(state),
  certificationsByMembershipAndSkillId: certificationSelectors.certificationsByMembershipAndSkillId(state)
});

const mapDispatchToProps = {
  fetchSkills: skillOperations.fetch,
  fetchMemberships: membershipOperations.fetch,
  fetchUsers: userOperations.fetch,
  fetchCertifications: certificationOperations.fetch,
  assignSkill: certificationOperations.assignSkill
};

export default connect(mapStateToProps, mapDispatchToProps)(SkillEditTable);
